import { Schema } from "@effect/schema";

export type KvJsonMeta = typeof KvJsonMeta.Type;
export type KvJsonMetaEncoded = typeof KvJsonMeta.Encoded;

export const KvJsonMeta = Schema.Struct({
  $lastUpdated: Schema.String,
}).annotations({ identifier: "KvJsonMeta" });

export function getLastUpdated(): string {
  return new Date().toISOString();
}
